import { FunctionComponent, HTMLAttributes } from 'react';

const IconACTWhite2: FunctionComponent<HTMLAttributes<HTMLOrSVGElement>> = (
  props
) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.25 7.5C14.3211 7.5 16 5.82107 16 3.75C16 1.67893 14.3211 0 12.25 0C10.1789 0 8.5 1.67893 8.5 3.75C8.5 5.82107 10.1789 7.5 12.25 7.5ZM11.65 2.1C11.65 1.76863 11.9186 1.5 12.25 1.5C12.5814 1.5 12.85 1.76863 12.85 2.1V3.15H13.9C14.2314 3.15 14.5 3.41863 14.5 3.75C14.5 4.08137 14.2314 4.35 13.9 4.35H12.85V5.4C12.85 5.73137 12.5814 6 12.25 6C11.9186 6 11.65 5.73137 11.65 5.4V4.35H10.6C10.2686 4.35 10 4.08137 10 3.75C10 3.41863 10.2686 3.15 10.6 3.15H11.65V2.1Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.4568 7.95736C13.7974 8.30391 13.0466 8.5 12.25 8.5C9.79553 8.5 7.77586 6.63833 7.52601 4.24999H3.50646L3.23918 2.4452C3.23157 2.37553 3.20965 2.31016 3.17642 2.2521C3.15349 2.21193 3.12526 2.17554 3.09285 2.1437C3.02889 2.08076 2.94807 2.0349 2.85777 2.01352C2.81765 2.00396 2.77593 1.9993 2.73341 2.00009H0.500001C0.223858 2.00009 0 2.22395 0 2.50009C0 2.77623 0.223858 3.00009 0.500001 3.00009H2.31093L3.76293 12.8046C3.77096 12.8786 3.79515 12.9477 3.83189 13.0085C3.9005 13.1219 4.01289 13.2058 4.14564 13.2369C4.18538 13.2462 4.22668 13.2508 4.26875 13.25H13.5C13.7762 13.25 14 13.0261 14 12.75C14 12.4739 13.7762 12.25 13.5 12.25H4.69122L4.5061 11H13.5049C13.7572 11 13.9659 10.8131 14 10.5702L14.4568 7.95736ZM5.75001 15C5.75001 15.5523 5.30229 16 4.75001 16C4.19772 16 3.75001 15.5523 3.75001 15C3.75001 14.4477 4.19772 14 4.75001 14C5.30229 14 5.75001 14.4477 5.75001 15ZM14 15C14 15.5523 13.5523 16 13 16C12.4477 16 12 15.5523 12 15C12 14.4477 12.4477 14 13 14C13.5523 14 14 14.4477 14 15Z"
      fill="currentColor"
    />
  </svg>
);

export default IconACTWhite2;
